var map = {
	"./bag-soy.jpg": 60834,
	"./barley-field.jpg": 22954,
	"./barley.jpg": 93533,
	"./beer-barley.jpg": 48468,
	"./beer.jpg": 55648,
	"./brewery.jpg": 18426,
	"./corn-field.jpg": 81107,
	"./corn-harvest.png": 18108,
	"./corn-oil.jpg": 82335,
	"./gas-pump.png": 81776,
	"./growlers.jpg": 76427,
	"./heat-map.png": 27050,
	"./hops.jpg": 34738,
	"./ios_mp.png": 31179,
	"./lloyd-larry.jpg": 66057,
	"./market_colour.png": 64727,
	"./oil-barrels.jpg": 47812,
	"./oldscollege.jpg": 92205,
	"./pig.jpg": 87408,
	"./silos.jpg": 79842,
	"./soybeans.jpg": 48738,
	"./tofu.png": 26750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26648;